import { GenericApi } from './generic.api';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Brand } from '../model/ddb.model';
import { Observable } from 'rxjs';
import { HasId } from '../model/generics';
import { QueryResult } from '../model/query.filter.class';
import { createUrl, getPublicRoutesHeaders } from './api.util';

// Convenience Type
type T = Brand;

@Injectable()
export class BrandApi extends GenericApi<T> {
  public path = "brand";

  constructor(
    public httpClient: HttpClient
  ) {
    super(httpClient);
  }

  getBrandDetail(id: number | string): Observable<Brand> {
    return this.httpClient.get<Brand>(
      createUrl(this.path, id),
      { headers: getPublicRoutesHeaders() }
    );
  };

  readonly getUnauthBrands = (
  ): Observable<QueryResult<Brand & HasId<string>>> => {
    return this.httpClient.get<QueryResult<Brand & HasId<string>>>(
      createUrl(this.path, "all"),
      { headers: getPublicRoutesHeaders() }
    );
  };

  readonly restore = (id: number | string): Observable<{ success: boolean }> =>
    this.httpClient.get<{ success: boolean }>(
      createUrl(this.path, id, "restore"),
      {}
    );
}
